import React from 'react';

import SpeedOverrideList from './components/speedOverrideList';

const SpeedOverride = (props) => {

    const { mapRef } = props

    return (
        /* enable has permision if is necesary */
        <SpeedOverrideList mapRef={mapRef} />
    )

}

export default SpeedOverride;